export default "__VITE_ASSET__BDSZyjcB__"